import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { StockTakeSessionRecordCriteriaModelQuery, StockTakeSessionRecordQueryCriteriaClass } from '../../../criteria/stock';
import { StockTakeSessionRecordModel } from '../../../../../../models/aggregates/erp/stock';

@Injectable({ providedIn: 'root' })
export class StockTakeSessionRecordService extends BaseApiTemplateService<StockTakeSessionRecordModel > {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-record';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-record';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'stocktake-record';
    this.httpClient = theHttp;
  }

  getStockTakeSessionRecordByCriteria(visa: ApiVisa, criteria?: StockTakeSessionRecordQueryCriteriaClass):
    Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildStockTakeDeviceCriteria = new StockTakeSessionRecordCriteriaModelQuery(criteria);
    console.log('OverRide stockDevice-hdr: ', buildStockTakeDeviceCriteria.query);
    return this.httpClient.get<PagingResponseModel<any>>(this.apiUrl + '/query?' + buildStockTakeDeviceCriteria.query, this.getHttpHeader(visa));
  }

  insertMultiStockTakeSessionRecord(dtoObject: StockTakeSessionRecordModel[],visa: ApiVisa)
  {
    let url = this.apiUrl + '/multi';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/multi';
    }
    return this.httpClient.post<ApiResponseModel<StockTakeSessionRecordModel[]>>(url, dtoObject, this.getHttpHeader(visa));
  }

  getStockTakeSessionRecordInvItemDevice(
    pagination: Pagination,
    visa: ApiVisa
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/inv-item-devices/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
